<script>
    import { mapGetters } from "vuex";
    import TheSlider from "@main/packages/TheSlider";
    import ProductCard from "@miku-kz/components/ProductCard";
    import { RECIPES_PRODUCTS_BREAKPOINTS } from "@miku-kz/settings/breakpoints";

    export default {
        name: "RecipeProducts",
        components: {
            TheSlider,
            ProductCard,
        },
        props: {
            products: Array,
        },
        computed: {
            ...mapGetters("Root", ["productsInCartIds"]),
            options() {
                return {
                    ...RECIPES_PRODUCTS_BREAKPOINTS,
                };
            },
        },
    };
</script>

<template>
    <div class="recipe-products">
        <div class="recipe-products__list">
            <the-slider
                nameSlider="recipeProducts"
                :is-bullets="true"
                :bullets-options="{ dynamicBullets: true }"
                arrow-position="bottom"
                :options="options"
                :list="products"
            >
                <product-card
                    slot="swiper-slide"
                    class="swiper-slide"
                    v-for="(product, index) in products"
                    :key="product.id"
                    :product="product"
                    :position="index"
                    :in-cart-list="productsInCartIds"
                    is-small
                ></product-card>
            </the-slider>
        </div>
    </div>
</template>

<style lang="scss">
    .recipe-products__list {
        .swiper-container {
            margin: 0 -16px;
            padding: 4px 16px 24px;
            @include bp($bp-desktop-sm) {
                margin: -12px -16px 0;
                padding: 12px 16px 24px;
            }
        }
        .c-slider__bottom-wrapper {
            margin-top: 0;
        }
        .c-slider__arrow {
            display: none;
            @include bp($bp-desktop-sm) {
                display: flex;
            }
        }
    }
</style>
